import { stripLocalePrefix } from "./localeRouting";

export const CLARITY_PROJECT_ID = "tpu5gjxk0d";
export const CLARITY_DISABLE_SESSION_KEY = "lukkey_disable_clarity";

const getClarity = () => {
  if (typeof window === "undefined") return null;
  return typeof window.clarity === "function" ? window.clarity : null;
};

const CLARITY_SENSITIVE_PATH_PREFIXES = [
  "/admin",
  "/audit",
  "/design",
  "/r2-files",
  "/scm",
  "/brc20",
  "/jaime",
  "/internal",
  "/financial",
  "/finance",
  "/demo",
  "/lukkey-issues",
  "/workspace",
  "/issues",
  "/3drender",
];

export const claritySet = (key, value) => {
  const clarity = getClarity();
  if (!clarity || !key || value === undefined || value === null) return;
  clarity("set", key, String(value));
};

export const clarityEvent = (name) => {
  const clarity = getClarity();
  if (!clarity || !name) return;
  clarity("event", String(name));
};

export const getDeviceGroup = () => {
  if (typeof window === "undefined") return "desktop";
  const width = window.innerWidth || 0;
  if (width < 768) return "mobile";
  if (width < 1280) return "tablet";
  return "desktop";
};

export const getClarityPageGroup = (pathname = "/") => {
  const normalized = stripLocalePrefix(String(pathname || "/"));

  if (isClaritySensitivePath(normalized)) return null;

  if (normalized === "/") return "home";
  if (normalized === "/lukkey") return "lukkey";
  if (normalized === "/privacy") return "privacy";
  if (normalized === "/terms-of-service") return "terms_of_service";
  if (normalized === "/about-us") return "about_us";
  if (normalized === "/social" || normalized === "/community") return "social";
  if (normalized === "/supported-crypto-assets") return "supported_crypto_assets";
  if (normalized === "/help-center") return "help_center";
  if (normalized.startsWith("/help-center/")) return "help_center_article";
  if (normalized === "/support-request") return "support_request";
  if (normalized === "/subscribe/confirmed") return "subscribe_confirmed";
  if (normalized === "/purchase/success") return "purchase_success";
  if (normalized === "/academy") return "academy";
  if (normalized.startsWith("/academy/")) return "academy_article";
  if (normalized === "/pre") return "lukkey_preorder";

  return "other";
};

export const getClarityPageTemplate = (pathname = "/") => {
  const normalized = stripLocalePrefix(String(pathname || "/"));

  if (isClaritySensitivePath(normalized)) return null;

  if (normalized.startsWith("/help-center/")) return "/help-center/:slug";
  if (normalized.startsWith("/academy/")) return "/academy/:slug";

  return normalized;
};

export const isClaritySensitivePath = (pathname = "/") => {
  const normalized = stripLocalePrefix(String(pathname || "/"));
  return CLARITY_SENSITIVE_PATH_PREFIXES.some(
    (prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`)
  );
};

export const clearClarityCookies = () => {
  if (typeof document === "undefined") return;

  const expires = "Thu, 01 Jan 1970 00:00:00 GMT";
  const cookies = ["_clck", "_clsk"];
  const host =
    typeof window !== "undefined" ? String(window.location?.hostname || "") : "";
  const hostParts = host.split(".").filter(Boolean);
  const domains = new Set([""]);

  for (let index = 0; index < hostParts.length - 1; index += 1) {
    domains.add(`.${hostParts.slice(index).join(".")}`);
  }

  cookies.forEach((cookieName) => {
    domains.forEach((domain) => {
      const domainPart = domain ? `; domain=${domain}` : "";
      document.cookie = `${cookieName}=; expires=${expires}; path=/${domainPart}`;
    });
  });
};
